"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var map = {};
/**
 * 生成唯一 ID
 * @param prefix 前缀
 * @returns 唯一 ID
 */
function uniqueId(prefix) {
    if (prefix === void 0) { prefix = "g"; }
    if (!map[prefix]) {
        map[prefix] = 1;
    }
    else {
        map[prefix] += 1;
    }
    return prefix + map[prefix];
}
exports.uniqueId = uniqueId;
//# sourceMappingURL=unique-id.js.map